import API from '@/api/index';
import * as Auth from '@/utils/auth';

const user = {
  state: {
    token: Auth.getAccessToken(),
    refreshToken: Auth.getRefreshToken(),
    loggedUser: Auth.getLoggedUser(),
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
      Auth.setAccessToken(token);
    },
    SET_LOGGED_USER: (state, loggedUser) => {
      Auth.setLoggedUser(loggedUser);
      state.loggedUser = loggedUser;
    },
    

    SET_REFRESH_TOKEN: (state, refreshToken) => {
      state.refreshToken = refreshToken;
      Auth.setRefreshToken(refreshToken);
    },
    SET_CLIENT_ID: (state, clientID) => {
      state.clientID = clientID;
      Auth.setClientId(clientID);
    }
  },

  actions: {
    loginByUsername ({ commit }, model) {
      return new Promise((resolve, reject) => {
        API.user
          .loginByUsername(model)
          .then(response => {
            let result = response.data;
            
            if (result.Data) {
              let token = {
                access_token: result.Data.Token,
                refresh_token: result.Data.Token
              };
              commit('SET_TOKEN', token);

              let loggedUser = result.Data.LoggedUser;
              commit('SET_LOGGED_USER', loggedUser);

              resolve(token);
            } else {
              reject(result.Code);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    logOut ({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_LOGGED_USER', '');

        Auth.removeToken();
        Auth.removeClientId();
        resolve();
      });
    },
    // refreshToken: ({ commit }, token) => commit('SET_TOKEN', token),

    refreshToken ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .refreshToken(data)
          .then(response => {
            let result = response.data;
            if (!result.code && result.data) {
              let token = result.data.accessToken;
              commit('SET_TOKEN', token);
              commit('SET_TOKEN_TYPE', result.data.tokenType);
              commit('SET_REFRESH_TOKEN', result.data.refreshToken);
              resolve(result.data);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    
    getUserProfile ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .getUserProfile(data)
          .then(response => {
            let result = response.data;
            if (!result.error) {
              let profile = result.data;
              if (profile && profile.profile && profile.profile.Users) { commit('SET_LOGGED_USER', profile.profile.Users) }
              resolve(profile);
            } else {
              reject(response.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getInternalApp ({ commit }, data) {
      return new Promise((resolve, reject) => {
        API.user
          .getInternalApp(data)
          .then(response => {
            let result = response.data;
            if (!result.error) {
              resolve(result.data);
            } else {
              reject(result.data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js